import AudioManager from "../../../../manager/audio_manager";
import Utility from "../../../../utility/utility";
import TimeManager from "../../../../manager/time_manager";

const { ccclass, property } = cc._decorator;
const const_bipai_malePath: string = 'package/bipai/sound/male/'
const const_bipai_femalePath: string = 'package/bipai/sound/female/'
const const_bipai_effectPath: string = 'package/bipai/sound/'
const const_bipai_musicPath: string = 'package/bipai/sound/bgm/'
const const_musicPath: string = 'package/q2/sound/bgm/'
const const_effectPath: string = 'package/q2/sound/effect/'
const const_soundPath: string = 'package/q2/sound/'

export default class Q2TableSound{
    protected m_clock_tick_sound_id: number = 0
    protected m_target_volume: number = 0
    protected m_time_event_id: number = 0
    playBgm(){
        // let soundName = 'dummy_room_bgm'
        // this.playMusic(const_musicPath + soundName, soundName)
        let soundName = 'bi_pai_q2'
        this.playMusic(const_bipai_musicPath + soundName, soundName)
        this.m_target_volume = cc.audioEngine.getMusicVolume()
    }

    playCardTypeSound(male: boolean, count: number, index: number, onFinish?: Function){
        let soundName = count + '_' + index
        let rootPath = male? const_bipai_malePath: const_bipai_femalePath
        this.playSound(rootPath + soundName, soundName, onFinish)
    }

    playHuQ2Sound(male: boolean, onFinish?: Function){
        let soundName = 'dummy_draw2q_' + (male? 'm': 'f')
        this.playSound(const_soundPath + soundName, soundName, onFinish)
    }

    playRaiseSound(male: boolean, onFinish?: Function){
        let soundName = 'dummy_create_' + (male? 'm': 'f')
        this.playSound(const_soundPath + soundName, soundName, onFinish)
    }
    playStorageSound(male: boolean, onFinish?: Function){
        let soundName = 'dummy_lay_' + (male? 'm': 'f')
        this.playSound(const_soundPath + soundName, soundName, onFinish)
    }
    playAttachSound(male: boolean, onFinish?: Function){
        let soundName = 'dummy_save_' + (male? 'm': 'f')
        this.playSound(const_soundPath + soundName, soundName, onFinish)
    }
    playHuDummySound(male: boolean, onFinish?: Function){
        let soundName = 'dummy_draw_dummy_' + (male? 'm': 'f')
        this.playSound(const_soundPath + soundName, soundName, onFinish)
    }

    playShowQ2Sound(male: boolean, onFinish?: Function){
        let soundName = 'dummy_show2q_' + (male? 'm': 'f')
        this.playSound(const_soundPath + soundName, soundName, onFinish)
    }
    playHuPaiSound(male: boolean, onFinish?: Function){
        let soundName = 'dummy_draw_' + (male? 'm': 'f')
        this.playSound(const_soundPath + soundName, soundName, onFinish)
    }
    playLianJiHuSound(male: boolean, onFinish?: Function){
        let soundName = 'dummy_draw_cont_' + (male? 'm': 'f')
        this.playSound(const_soundPath + soundName, soundName, onFinish)
    }
    playHeadSound(male: boolean, onFinish?: Function){
        let soundName = 'dummy_head_' + (male? 'm': 'f')
        this.playSound(const_soundPath + soundName, soundName, onFinish)
    }

    playQingYiSeSound(male: boolean, onFinish?: Function){
        let soundName = 'dummy_uniform_' + (male? 'm': 'f')
        this.playSound(const_soundPath + soundName, soundName, onFinish)
    }

    playChengPaiEffectSound(onFinish?: Function){
        let soundName = 'dummy_create_di'
        this.playSound(const_effectPath + soundName, soundName, onFinish)
    }

    playMyTurnEffectSound(onFinish?: Function){
        let soundName = 'dummy_speak'
        this.playSound(const_effectPath + soundName, soundName, onFinish)
    }

    playClockTickEffectSound(onFinish?: Function){
        let soundName = 'dummy_count_down'
        this.playSound(const_effectPath + soundName, soundName, ()=>{
            this.m_clock_tick_sound_id = 0
            onFinish && onFinish()
        }, (id)=>{
            this.m_clock_tick_sound_id = id
        })
    }

    stopClockTickEffectSound(){        
        this.m_clock_tick_sound_id && this.stopSound(this.m_clock_tick_sound_id)
    }

    playBombEffectSound(onFinish?: Function){
        let soundName = 'dummy_bomb'
        this.playSound(const_effectPath + soundName, soundName, onFinish)
    }

    playShowQ2EffectSound(onFinish?: Function){
        let soundName = 'dummy_show2Q'
        this.playSound(const_effectPath + soundName, soundName, onFinish)
    }

    playWinEffectSound(onFinish?: Function){
        let soundName = 'dummy_victory'
        this.playSound(const_effectPath + soundName, soundName, onFinish)
    }

    playLoseEffectSound(onFinish?: Function){
        let soundName = 'dummy_lose'
        this.playSound(const_effectPath + soundName, soundName, onFinish)
    }

    playDrawEffectSound(onFinish?: Function){
        let soundName = 'dummy_draw'
        this.playSound(const_effectPath + soundName, soundName, onFinish)
    }

    playDiscardEffectSound(onFinish?: Function){
        let soundName = 'dummy_discard_card'
        this.playSound(const_effectPath + soundName, soundName, onFinish)
    }

    playDealCardEffectSound(onFinish?: Function){
        let soundName = 'dummy_deal_card'
        this.playSound(const_effectPath + soundName, soundName, onFinish)
    }

    playShowWinCardEffectSound(onFinish?: Function){
        let soundName = 'dummy_show_win_card'
        this.playSound(const_effectPath + soundName, soundName, onFinish)
    }

    //被放q2
    playPunishedQ2EffectSound(onFinish?: Function){
        let soundName = 'dummy_be_punished_2q'
        this.playSound(const_effectPath + soundName, soundName, onFinish)
    }


    playHeadEffectSound(onFinish?: Function){
        let soundName = 'dummy_head'
        this.playSound(const_effectPath + soundName, soundName, onFinish)
    }


    //光头
    playZeroEffectSound(onFinish?: Function){
        let soundName = 'dummy_zero'
        this.playSound(const_effectPath + soundName, soundName, onFinish)
    }


    //丢成牌、丢dummy牌、丢头牌
    playDiuFenEffectSound(onFinish?: Function){
        let soundName = 'dummy_discard_punish'
        this.playSound(const_effectPath + soundName, soundName, onFinish)
    }

    playClickSortBtnEffectSound(onFinish?: Function){
        let soundName = 'q2_change_poker'
        this.playSound(const_effectPath + soundName, soundName, onFinish)
    }

    playClickPokerEffectSound(onFinish?: Function){
        let soundName = 'dummy_click_poker'
        this.playSound(const_effectPath + soundName, soundName, onFinish)
    }

    playSound(fullPath:string, soundName: string, onFinish: Function, onStart?: Function){
        AudioManager.instance.playSound(fullPath, false, onFinish, onStart)
    }

    playMusic(fullPath: string, soundName: string){
        AudioManager.instance.playMusic(fullPath, false)
    }

    pauseMusic(){
        AudioManager.instance.pauseMusic()
    }

    resumeMusic(){
        AudioManager.instance.resumeMusic()
    }

    stopSound(id: number){
        AudioManager.instance.stopSound(id)
    }

    stopBgm(){
        AudioManager.instance.stopAllMusic()
    }

    fadeInBgm(){
        let targetVolume = this.m_target_volume
        let volume = cc.audioEngine.getMusicVolume()
        let speed = 1
        let dt = 0.1
        this.fadeVolume(volume, speed, dt, targetVolume, true)
    }

    fadeOutBgm(){
        let volume = this.m_target_volume = cc.audioEngine.getMusicVolume()
        let speed = 1
        let dt = 0.1
        this.fadeVolume(volume, speed, dt, 0, false)
    }

    protected fadeVolume(volume: number, speed: number, dt: number, targetVal: number, fadeIn: boolean){
        if(this.m_time_event_id){
            TimeManager.instance.cancelSchedule(this.m_time_event_id)
        }
        this.m_time_event_id = TimeManager.instance.doScheduleOnce(()=>{            
            fadeIn? volume += speed * dt: volume -= speed * dt
            AudioManager.instance.setMusicVolume(volume)
            if(fadeIn){
                if(volume >= targetVal){
                    volume = targetVal
                    return
                }
            }else{
                if(volume <= targetVal){
                    volume = targetVal
                    return
                }
            }
            this.fadeVolume(volume, speed, dt, targetVal, fadeIn)            
        }, dt)
    }

    private getRandomIndex(under: number = 0, over: number = 0){
        return Utility.getIntRandom(under, over)
    }

    release(){
        if(this.m_time_event_id){
            TimeManager.instance.cancelSchedule(this.m_time_event_id)
        }
    }
}